var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:{'_popup': !_vm.posModal, '_transition': _vm.displayStartInfo},on:{"click":function($event){return _vm.clickOutside($event)}}},[_c('div',{staticClass:"modal__content",style:(_vm.style)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }